// tslint:disable
export enum AccountContactInformationPurposeType {
    // UNKN
    UNKN = 0,
    // MAIN
    MAIN = 1,
    // MKTG
    MKTG = 2,
    // SALES
    SALES = 3,
    // CUSTSER
    CUSTSER = 4,
    // HOME
    HOME = 5,
    // WORK
    WORK = 6,
    // SEAS
    SEAS = 7,
    // OTHR
    OTHR = 8,
}
